import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackRegist } from "./callbacks/callbackRegist";
import { callbackLogin } from "./callbacks/callbackLogin";
import { callbackResetPassword } from "./callbacks/callbackResetPassword";
import { callbackValidateResetToken } from "./callbacks/callbackValidateResetToken";
import { callbackSetNewPassword } from "./callbacks/callbackSetNewPassword";
import { callbackProfile } from "./callbacks/callbackProfile";
import { EnumAPIKey } from "@/constants/app/api";

export const userEndpoints = {
  [EnumEndpointsName.LOGIN]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.LOGIN,
    api: EnumAPIKey.API_CUSTOMER,
    caller: callbackLogin
  },
  [EnumEndpointsName.REGIST]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.REGIST,
    api: EnumAPIKey.API_CUSTOMER,
    caller: callbackRegist
  },
  [EnumEndpointsName.PROFILE]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.PROFILE,
    api: EnumAPIKey.API_CUSTOMER,
    caller: callbackProfile
  },
  [EnumEndpointsName.UPDATE]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.UPDATE,
    api: EnumAPIKey.API_CUSTOMER,
  },
  [EnumEndpointsName.FORCE_SEND_MAIL]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.FORCE_SEND_MAIL,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.LOGOUT]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.LOGOUT,
    api: EnumAPIKey.API_CUSTOMER
  },
  [EnumEndpointsName.RESET_PASSWORD]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.RESET_PASSWORD,
    api: EnumAPIKey.API_CUSTOMER,
    caller: callbackResetPassword
  },
  [EnumEndpointsName.VALIDATE_RESET_TOKEN]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.VALIDATE_RESET_TOKEN,
    api: EnumAPIKey.API_CUSTOMER,
    caller: callbackValidateResetToken
  },
  [EnumEndpointsName.SET_NEW_PASSWORD]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.SET_NEW_PASSWORD,
    api: EnumAPIKey.API_CUSTOMER,
    caller: callbackSetNewPassword
  },
  [EnumEndpointsName.MY_VOUCHERS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.MY_VOUCHERS,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.VOUCHERS]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.VOUCHERS,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.CUSTOMER_TEMP]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.CUSTOMER_TEMP,
    api: EnumAPIKey.API_CUSTOMER,
  }
}